// SPA 埋点 SDK 初始化（jg-cust-vue）
// 在 main.js 引入本文件即可：它创建单例并注入 Vue.prototype.$tracker
import Vue from 'vue'
import Tracker from './tracker.js'

const tracker = new Tracker({
  endpoint: '/track/event',
  identifyEndpoint: '/track/identify'
})

// 注入全局，业务代码用 this.$tracker.track(...) / this.$tracker.identify(...)
Vue.prototype.$tracker = tracker

export default tracker



// WEBPACK FOOTER //
// ./src/analytics/index.js